import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { StoreState } from '@store/store.state';
import { languageSelectors } from '@store/selectors/language.selectors';

export const langInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store<StoreState>);
  return next(
    req.clone({
      setHeaders: {
        'Accept-Language': store.selectSignal(languageSelectors.currentLanguage)(),
      },
    })
  );
};
